import type { INavigator } from '@talbenmoshe/phrasier-auth-client';

export class WindowNavigator implements INavigator {
  navigateTo(url: string): void {
    window.location.href = url;
  }
}
